<template>
  <button @click.prevent="onClick" class="cta u-uppercase u-center u-bg-white u-relative">
    <div class="cta__base u-black">
      <slot></slot>
    </div>
    <div class="cta__hover u-wrapper-panel u-white u-bg-black">
      <div class="cta__hover__content">
        <slot></slot>
      </div>
    </div>
  </button>
</template>


<script>
export default {
  props: {
    to: {
      type: Object,
      default: () => { return {}}
    }
  },
  methods: {
    onClick () {
      if (this.disabled) return

      this.$emit('click')

      if (Object.keys(this.to).length) {
        this.$router.push(this.to)
      }
    }
  }
}
</script>


<style scoped lang="stylus">
@import '~@/styles/settings/variables'
@import '~@/styles/settings/easings'

borderRadius = 25px

.cta
  font-family univers
  font-weight $weights.bold
  border-radius borderRadius
  font-size 18px
  line-height 1.4em
  overflow hidden
  padding 0

  &:after
    content ''
    border solid 2px $colors.white    
    position absolute
    border-radius borderRadius
    top 0
    left 0
    height 100%
    width 100%

  &__base, &__hover__content
    padding 14px 25px 10px
    
  &__hover
    margin-left 2px
  
  &__hover
    transform translate3d(0, 100%, 0)
    transition transform .3s ease-in-out-sine
    overflow hidden
    
    &__content
      transition transform .3s ease-in-out-sine
      transform translate3d(0, -100%, 0)

  &:hover &__hover
    transform translate3d(0, 0, 0)

    &__content
      transform translate3d(0, 0, 0)

</style>
